import { render, staticRenderFns } from "./VmSearch.vue?vue&type=template&id=6f498faa&scoped=true&"
import script from "./VmSearch.vue?vue&type=script&lang=js&"
export * from "./VmSearch.vue?vue&type=script&lang=js&"
import style0 from "./VmSearch.vue?vue&type=style&index=0&id=6f498faa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f498faa",
  null
  
)

export default component.exports